import React, { useEffect, useState } from "react";
import Card from "../CardCont/CardCont";
import "./Containerset2.css";
import styled from "styled-components";

const ContainerSet2 = ({list}) => {

 const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const itemsToShow = isMobile
    ? list.items.slice(0, 8)
    : list.items.slice(0, 9);

  const Container = styled.div`
  
  `

  const first9Items = list.items.slice(0, 9);
  const first8Items = first9Items.slice(0, 8);

  
  return (
    <div className="container-set2">
      <h2 className="container-set2-title" style={{ fontSize: "16px", textAlign: "center", marginBottom: "1rem" }}>
       Kitchen Storage
      </h2>
      <div className="container-set2-grid" >
        {itemsToShow.map((item, index) => (
          <Card key={index} item={item} />
        ))}
      </div>
      <style>{`
        .container-set2 {
        max-width: 700px;
        margin:unset;
     flex-1
     cursor: pointer;
      }
     .container-set2-grid{
     grid-template-columns: repeat(3, 1fr);
     gap:5px;
     }
.card:hover{
scale:unset important;
transform: unset;
}
        @media (max-width: 851px) {
          .container-set2 {
            margin: unset;
            padding: 1rem .2rem;
            
          }

             .container-set2-grid {
        grid-template-columns: repeat(3, 1fr) !important;
        gap: unset;
    }


      
        }

        @media (max-width: 600px) {
        
          .container-set2-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: unset;
          }
        }
      `}</style>
    </div>
  );
};

export default ContainerSet2;
